<div class="bg-shui-base-3 flex justify-between items-center gap-8 p-2 rounded-md">
    <sh-select
        class="w-24 hidden md:block"
        label="Items per page"
        [condensed]="true"
        [options]="pageSizeOptionsObjects()"
        [formControl]="pageSizeControl"
    ></sh-select>
    <div>
        <sh-pagination
            [pages]="Math.ceil(totalItems() / pageSize())"
            [current-page]="currentPage()"
            (clicked-page-move)="goToPageEvent($event)"
            (next-page-move)="nextPage()"
            (previous-page-move)="previousPage()"
        ></sh-pagination>
    </div>
</div>
